import ISiteLink from '../../links/ISiteLink';
import { useContext, useEffect } from 'react';
import AppContext from '../../../AppContext';
import AnnualChangeRowData from './AnnualChangeRowData';
import styles from './LinkRow.module.css';
import { YEAR_CELL_CLASS } from './yearRenderUtils';
import { buildScoringColumnUrl } from '../linkUrlUtils';

interface LinkRowProps extends AnnualChangeRowData {
  isVizExpanded?: boolean;
}

export default function LinkRow({
  label,
  linkURL,
  currentYear,
  priorYear,
  priorYearMinusOne,
  priorYearMinusTwo,
  priorYearMinusThree,
  priorYearMinusFour,
  priorYearMinusFive,
  priorYearMinusSix,
  priorYearMinusSeven,
  priorYearMinusEight,
  embeddedDashboardUrl: tableauDashboardUrl,
  isVizExpanded = true
}: LinkRowProps) {
  const { year, cocode, statementType, activeYearsMode } = useContext(AppContext);
  const showTenYearCells = activeYearsMode === 'TEN' && priorYearMinusFour !== undefined;

  useEffect(() => {
    if (!tableauDashboardUrl?.trim()) return;
    const scriptId = 'tableau-embedding-api';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'module';
      script.src = 'https://tableau.naic.org/javascripts/api/tableau.embedding.3.latest.min.js';
      document.head.appendChild(script);
    }
  }, [tableauDashboardUrl]);
  const currentYearNum = parseInt(year);

  let data: any = {
    currentYear: currentYear,
    priorYear: priorYear,
    priorYearMinusOne: priorYearMinusOne,
    priorYearMinusTwo: priorYearMinusTwo,
    priorYearMinusThree: priorYearMinusThree,
    priorYearMinusFour: priorYearMinusFour,
    priorYearMinusFive: priorYearMinusFive,
    priorYearMinusSix: priorYearMinusSix,
    priorYearMinusSeven: priorYearMinusSeven,
    priorYearMinusEight: priorYearMinusEight
  };

  if (label === 'Peer Report') {
    data.currentYear.value = year + ' Rpt';
    data.priorYear.value = year - 1 + ' Rpt';
    data.priorYearMinusOne.value = year - 2 + ' Rpt';
    data.priorYearMinusTwo.value = year - 3 + ' Rpt';
    data.priorYearMinusThree.value = year - 4 + ' Rpt';
    if (data.priorYearMinusFour) data.priorYearMinusFour.value = year - 5 + ' Rpt';
    if (data.priorYearMinusFive) data.priorYearMinusFive.value = year - 6 + ' Rpt';
    if (data.priorYearMinusSix) data.priorYearMinusSix.value = year - 7 + ' Rpt';
    if (data.priorYearMinusSeven) data.priorYearMinusSeven.value = year - 8 + ' Rpt';
    if (data.priorYearMinusEight) data.priorYearMinusEight.value = year - 9 + ' Rpt';
  }

  function renderYearLink(yearData: any, yearValue: number) {
    if (yearData?.showAsNA) {
      return <p className={`column_align_right ${YEAR_CELL_CLASS}`}>NA</p>;
    }
    return (
      <p className={`column_align_right ${YEAR_CELL_CLASS}`}>
        <ISiteLink
          relativeUrl={buildScoringColumnUrl(
            linkURL ?? '',
            statementType.statementTypeCode,
            cocode,
            yearValue
          )}
          label={yearData.value ?? yearData.textValue}
        />
      </p>
    );
  }

  return (
    <>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      {renderYearLink(data.currentYear, currentYearNum)}
      {renderYearLink(data.priorYear, currentYearNum - 1)}
      {renderYearLink(data.priorYearMinusOne, currentYearNum - 2)}
      {renderYearLink(data.priorYearMinusTwo, currentYearNum - 3)}
      {renderYearLink(data.priorYearMinusThree, currentYearNum - 4)}
      {showTenYearCells && (
        <>
          {renderYearLink(data.priorYearMinusFour, currentYearNum - 5)}
          {renderYearLink(data.priorYearMinusFive, currentYearNum - 6)}
          {renderYearLink(data.priorYearMinusSix, currentYearNum - 7)}
          {renderYearLink(data.priorYearMinusSeven, currentYearNum - 8)}
          {renderYearLink(data.priorYearMinusEight, currentYearNum - 9)}
        </>
      )}
      {tableauDashboardUrl?.trim() && isVizExpanded && (
        <div className={styles.tableauContainer}>
          <tableau-viz
            id="tableau-viz"
            src={tableauDashboardUrl}
            width="1400"
            hide-tabs
            toolbar="bottom"
          >
            <viz-parameter name="COCODE" value={cocode} />
            <viz-parameter name="YEAR" value={year} />
          </tableau-viz>
        </div>
      )}
    </>
  );
}
